module.exports = __webpack_public_path__ + "img/rocket-4.a0de25e0.svg";